import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 24, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: "easeOut" }}
  >
    {children}
  </motion.div>
);

export const Label = ({ children, className = "" }) => (
  <span className={`font-label text-xs sm:text-sm text-gold ${className}`}>{children}</span>
);

export const SectionTitle = ({ label, title, sub, center = true }) => (
  <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-14`}>
    {label && <Label>{label}</Label>}
    <h2 className="text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-tight mt-4">{title}</h2>
    {sub && <p className="text-base lg:text-lg text-white/70 mt-5 leading-relaxed">{sub}</p>}
  </div>
);
